/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { client, urlFor } from '@/sanity/client';
import { ProgressiveBlur } from '../ui/progressive-blur';
import { InfiniteSlider } from '../ui/infinite-slider';

export const Partners = () => {
	const [partners, setPartners] = useState<any[]>([]);

	useEffect(() => {
		const fetchPartners = async () => {
			const data = await client.fetch(`*[_type == "homePage"][0].partners{
				title,
				subtitle,
				partners[]{
					name,
					logo{
						asset->{
							url
						}
					},
					website
				}
			}`);
			setPartners(data.partners);
		};

		fetchPartners();
	}, []);

	if (!partners.length) {
		return <div>Loading...</div>;
	}

	return (
		<section className='flex flex-col justify-center items-center px-20 py-14 w-full rounded-none max-md:px-5 max-md:max-w-full'>
			<div className='w-full max-w-[1328px] max-md:max-w-full md:px-24'>
				<header className='max-w-full text-neutral-800 w-[427px]'>
					<h1 className='text-4xl font-bold leading-[40px] max-md:text-[30px] max-md:leading-[40px]'>
						People we <br />
						partner with.
					</h1>
				</header>

				{/* Desktop view - with ProgressiveBlur */}
				<div className=' w-full mt-16'>
					<div className='relative h-[120px] w-full overflow-hidden'>
						<div className='flex h-full w-full items-center gap-8'>
							<InfiniteSlider
								className='flex h-full w-full items-center'
								duration={30}
								gap={48}
							>
								{partners.map((partner, index) => (
									<div
										key={index}
										className='flex w-32 items-center justify-center'
									>
										<img
											src={urlFor(partner.logo).url()}
											alt={partner.name}
											className='object-contain'
											style={{
												width: 'auto',
												maxWidth: '150px',
												height: 'auto',
											}}
										/>
									</div>
								))}
							</InfiniteSlider>
						</div>
						<ProgressiveBlur
							className='pointer-events-none absolute top-0 left-0 h-full w-[200px]'
							direction='left'
							blurIntensity={0.2}
						/>
						<ProgressiveBlur
							className='pointer-events-none absolute top-0 right-0 h-full w-[200px]'
							direction='right'
							blurIntensity={0.2}
						/>
					</div>
				</div>
			</div>
		</section>
	);
};
